import * as dompack from 'dompack';
import * as formservice from '@webhare-publisher/forms/form.rpc.json';
import * as preload from '@webhare-system/compat/preload';
import { qSA } from 'dompack/extra/qsa';
import * as browser from "dompack/extra/browser";
import * as keyboard from "dompack/extra/keyboard";
var legacybase = require('@webhare-system/internal/legacybase');
var SelectionInterface = require('./selection');
var snapshots = require('./snapshots');
var TableEditor = require('./tableeditor');
var rangy = require('@webhare-system/frameworks/rangy/rangy13');
//var Moo = require('@webhare-system/frameworks/mootools/core');
var WHBase = require('@webhare-system/compat/base');
//var $ = Moo.$;
//var Class = Moo.Class;
import * as richdebug from "./richdebug";
import * as domlevel from "./domlevel";
var compatupload = require('@webhare-system/compat/upload');
const domtools = require('@webhare-system/dom/tools');

var editableFix;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Editor basic setup
//
//
// Define browser events, so they are recognized by MooTools' addEvent call
//Moo.Element.NativeEvents.cut = 2;
//Moo.Element.NativeEvents.DOMNodeRemoved = 2;
//Moo.Element.NativeEvents.selectionchange = 2;

/*
function GetEventModifierMask(event)
  {
    return 0 | (event.shift ? 1 : 0) | (event.ctrl ? 2 : 0) | (event.alt ? 4 : 0) | (event.meta ? 8 : 0);
  }

function ModifierCtrl(mask, withmeta)
  {
    return mask & 2 || (withmeta && mask & 8);
  }*/

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //  HTML values
  //

  // Get a plain text interpretation of the current rte contents
function GetOuterPlain(node)
{
  if(node.nodeType==1 || node.nodeType==11)
  {
    // Don't return contents of certain elements
    if (('|script|style|').indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0)
      return '';

    // Return certain elements as-is
    if (('|br|hr|img|').indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0)
      return GetNodeXML(node);

    var nodes=[];

    // Leave some element tags
    if (('|blockquote|table|tbody|tr|th|td|').indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0)
      nodes.push('<' + node.nodeName.toLowerCase() + GetNodeXML_Attributes(node) + '>');

    // Get subnode texts
    for(var subnode = node.firstChild;subnode;subnode=subnode.nextSibling)
      nodes.push(GetOuterPlain(subnode));

    // Add newline after certain elements
    if (('|blockquote|div|dd|dt|fieldset|form|h1|h2|h3|h4|h5|h6|li|p|pre|').indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0)
      nodes.push('<br/>');

    // Leave some element tags
    if (('|blockquote|table|tbody|tr|th|td|').indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0)
      nodes.push('</' + node.nodeName.toLowerCase() + '>');

    return nodes.join('');
  }
  if(node.nodeType==3)
  {
    if (!node.nodeValue)
      return '';
    var value = node.nodeValue.encodeAsValue();

    // Replace newlines with <br> nodes within pre elements
    for (node = node.parentNode; node; node = node.parentNode)
      if (('|pre|').indexOf('|' + node.nodeName.toLowerCase() + '|') >= 0)
        break;
    if (node)
      value = value.split('\r\n').join('\n')   // Replace \r\n with \n
                   .split('\r').join('\n')     // Replace \r with \n
                   .split('\n').join('<br/>'); // Replace \n with <br/>

    return value;
  }
  return '';
}


function GetNodeXML(node, inner)
{
  if(!node)
    return '';

  var s = [];
  switch (node.nodeType)
  {
    case 9: // document
      if (!inner)
        s.push('<html><body>');
      s.push(GetNodeXML(node.body, true));
      if (!inner)
        s.push('</body></html>');
      break;
    case 1: // element
      if (!node.childNodes.length)
      {
        // Don't export the bogus Mozilla line break node
        if (node.nodeName.toLowerCase() == 'br'
            && (node.getAttribute('_moz_editor_bogus_node') == 'TRUE'
                || node.getAttribute('type') == '_moz'))
          break;
        if (!inner)
          s.push('<' + node.nodeName.toLowerCase() + GetNodeXML_Attributes(node) + '/>');
      }
      else
      {
        if (!inner)
          s.push('<' + node.nodeName.toLowerCase() + GetNodeXML_Attributes(node) + '>');
        for (var child = node.firstChild; child; child = child.nextSibling)
          s.push(GetNodeXML(child, false));
        if (!inner)
          s.push('</' + node.nodeName.toLowerCase() + '>');
      }
      break;
    case 3: // text
      if (node.nodeValue)
        s.push(node.nodeValue.encodeAsValue());
      break;
  }
  return s.join('');
}

function GetNodeXML_Attributes(node)
{
  var s = [];
  for (var i = 0; i < node.attributes.length; ++i)
    s.push(' ' + node.attributes[i].nodeName.toLowerCase() + '="' + node.attributes[i].nodeValue.encodeAsValue() + '"');
  return s.join('');
}

/** Provides access to a single contenteditable area. Keeps track of selection, so it wont be lost
    through focus changes.

    Also handles attaching/detaching event listeners
*/
class EditArea
{
  // ---------------------------------------------------------------------------
  //
  // Initialize
  //

  /** Create a new EditArea
      @param node Contenteditable node
      @param framemanager PersistentIframe or SelfFrameManager in which the node resides
      @param options
  */
  constructor(node, framemanager, options)
  {
    /// Root element of edit area
    this.el = node;
    this.framemanager = framemanager;

    this.connected = false;
    /// Last retrieved selection
    this.lastselection = null;
    this.registeredevents = { };
  }

  // ---------------------------------------------------------------------------
  //
  // Helper functions
  //

  // ---------------------------------------------------------------------------
  //
  // Public API
  //

  destroy()
  {
    if (this.connected)
      this.disconnect();
  }

  connect()
  {
    this.el.contentEditable = true;

    var body = this.framemanager.getBody();
    for (let eventname of Object.keys(this.registeredevents))
      for (let callback of this.registeredevents[eventname])
        body.addEventListener(eventname, callback);

    this.connected = true;
  }

  disconnect()
  {
    this.el.contentEditable = false;

    var body = this.framemanager.getBody();
    for (let eventname of Object.keys(this.registeredevents))
      for (let callback of this.registeredevents[eventname])
        body.removeEventListener(eventname, callback);

    this.connected = false;
  }

  registerBodyEvent(name, callback)
  {
    (this.registeredevents[name] = this.registeredevents[name] || []).push(callback);
  }

  /// Return the frame object
  getFrame()
  {
    return this.framemanager.getFrame();
  }

  /// Return the document object
  getDoc()
  {
    return this.framemanager.getDoc();
  }

  /// Return the body node
  getBody()
  {
    return this.el;
  }

  getElementById(id)
  {
    return this.framemanager.getElementById(id);
  }

  getElementsByTagName(tag)
  {
    return this.framemanager.getElementsByTagName(tag);
  }

  toElement()
  {
    return this.framemanager.toElement();
  }

  getBodyHTML()
  {
    return this.framemanager.getBodyHTML();
  }

  setBodyHTML(newhtml)
  {
    this.framemanager.setBodyHTML(newhtml);
  }

  hasFocus()
  {
    return this.framemanager.hasFocus();
  }

  debugGetRawSelectionRange()
  {
    return this.framemanager.debugGetRawSelectionRange();
  }
}


class EditorUndoItem extends domlevel.UndoItem
{ constructor(editor, selection)
  {
    super(editor.getContentBodyNode());

    this.editor = editor;
    this.preselection = selection;

    this.presnapshot = snapshots.generateSnapshot(this.editor.getContentBodyNode(), selection);

    //IE11 support (need way to detect IE11!)
    //this.editor.getContentBodyNode().ownerDocument.execCommand('ms-beginUndoUnit');

    this.postselection = null;
    this.postsnapshot = null;
  }

  finish(selection)
  {
    if (!selection)
      throw "No selection in undoitem finish";

    super.finish();
    //this.postselection = selection.clone();

    this.postsnapshot = snapshots.generateSnapshot(this.editor.getContentBodyNode(), selection);

    //this.editor.getContentBodyNode().ownerDocument.execCommand('ms-endUndoUnit');
    this.onfinish && this.onfinish(this);
//    this.fireEvent('finish', this);
  }

  undo()
  {
    //super.undo();
    //console.log(this.postselection);
    //console.log('afterundo', richdebug.getStructuredOuterHTML(this.editor.getContentBodyNode(), this.preselection, true));
    //this.editor.selectRange(this.preselection);
    var range = snapshots.restoreSnapshot(this.editor.getContentBodyNode(), this.presnapshot);
    this.editor.selectRange(range);
  }

  redo()
  {
//    super.redo();

//    this.editor.selectRange(this.postselection);
    var range = snapshots.restoreSnapshot(this.editor.getContentBodyNode(), this.postsnapshot);
    this.editor.selectRange(range);
  }
}

var defaultimgplaceholder = "data:image/png;base64,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";



/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Undo stuff
//

// ---------------------------------------------------------------------------
//
// RTE single area editor
//

class EditorBase
{
  constructor(element, rte, options, pageframe)
  {
    this.editelement = null;

    this.editarea = null;

    this.selectingrange = false; // Currently busy selecting range. Needed for synchronous event selectionchange
    this.ignorenextfocus = false; // Needed to ignore range setting when refocusing body

    this.ultypes = [ "", "disc", "circle", "square" ];
    this.oltypes = [ "", "decimal", "lower-roman", "upper-roman" ];
    this.actiontargets = [];

    this.delayedsurrounds = [];

      // Undo stuff
    this.undostack = [];
    this.undopos = 0;

      // input event stuff
    this.oninputhandlers = [];
    this.activeinputhandler = '';

    this.tableeditors = [];
    this.repeatupdatetableuntil = null;
    this.attachedinputevents = false;
    this.inputeventfunction = null;
    this.blockroots = [ 'body', 'td', 'th' ];

    this.tableeditorstatechangedelay = null;

    //this.browser = null;


    rangy.init();
    this.options =
        { log: false
        , contentareawidth: null
        , allowundo: false
        , imgloadplaceholder: null //image loader GIF image to use (defaults to embedded spinning loader)
        , eventnode: null
        , ...options
        , actionelements: [...((options && options.actionelements) || []) ] //elements on which we support actions, such as properties
        };

//    this.setOptions(options);
    this.editelement = element;
    this.editarea = new EditArea(element, pageframe, {});

    //if(this.options.log) console.log('apply saved state');
    //this.stateHasChanged(true);

    this.onload && this.onload();

    if(this.options.log) console.log('onloadcompletedelayed finished');

    // Listen to focus and focusout/focusin (focusin is needed on IE11, focus runs after the element gets focus
    // (rob: my guess is that happens when the old focused element disappears, but not sure)
    this.editarea.registerBodyEvent('focus', this.onFocus.bind(this));
    this.editarea.registerBodyEvent('focusout', this.onFocusOut.bind(this));
    this.editarea.registerBodyEvent('focusin', this.onFocusIn.bind(this));

    this._registerFrameEventListeners();

    if(!this.options.eventnode)
      throw Error("No eventnode");
    this.rte=rte;
    this.lastselectionstate = new TextFormattingState();
    //this.InitializeBrowserCapabilities();

    this.language = options && options.language || 'en';
    this.SetBreakupNodes(options && options.breakupnodes);
//    this.stateHasChanged();
  }

  destroy()
  {
    if(this.fontslistener)
      document.fonts.removeEventListener("loadingdone", this.fontslistener);

    if (this.scheduledupdatetableeditors)
    {
      cancelAnimationFrame(this.repeatupdatetableanimframe);
      clearTimeout(this.repeatupdatetabletimeout);
    }

    this.editarea.destroy();
  }


  getDoc()
  {
    return this.editelement.ownerDocument;
  }

  applyInnerHTML(html) //structured RTE overrides this
  {
    this.getContentBodyNode().innerHTML = html;
  }

  execCommand(command, p1, p2)
  {
    try
    {
      // execCommand should be called on the document, not the editable area (contenteditable/designmode)
      this.editelement.ownerDocument.execCommand(command, p1, p2);
    }
    catch (e)
    {
      if(this.options.log)
        console.log('ExecCommand exception',e);
      return false;
    }
    return true;
  }

  // ---------------------------------------------------------------------------
  //
  // Helper functions - selection
  //

  /** Make sure a range doesn't contain 2 tds or straddles into another table
      @param range
      @return
      @cell changed
      @cell range
  */
  _constrainRangeCrossTDSelections(range)
  {
    let changed = false;
    let base = range.getAncestorElement();

    range = range.clone();
    const startpath = range.start.getPathFromAncestor(base).reverse();
    for (let i = 0; i < startpath.length; ++i)
    {
      let node = startpath[i];
      if (node.nodeType === 1 && ([ "td", "th" ].includes(node.nodeName.toLowerCase())))
      {
        range.intersect(domlevel.Range.fromNodeInner(node));
        changed = true;
        break;
      }
    }

    // Get new base in case we have corrected
    base = range.getAncestorElement();

    // if the end locator points within an inner table
    let endpath = range.end.getPathFromAncestor(base).reverse();
    for (let i = 0; i < endpath.length; ++i)
    {
      let node = endpath[i];
      if (node.nodeType === 1 && node.nodeName.toLowerCase() === "table")
      {
        let locator = new domlevel.Locator.newPointingTo(node);
        locator.scanBackward(this.getContentBodyNode(), { whitespace: true, blocks: true }); // if we set past the last block elt, we'll delete that linebreak too, too dangerous
        if (range.start.compare(locator) <= 0)
          range.end.assign(locator);
        else
          range.end.assign(range.start);
        changed = true;
        break;
      }
    }

    return { changed, range };
  }

  // ---------------------------------------------------------------------------
  //
  // Helper functions - focus stuff
  //

  hasFocus()
  {
    return this.editarea.hasFocus();
  }

  takeFocus()
  {
    this.editelement.focus();
  }

  // ---------------------------------------------------------------------------
  //
  // Public API
  //

  getContentBodyNode()
  {
    return this.editarea.getBody();
  }

  setContentsHTML(htmlcode)
  {
    this.editarea.setBodyHTML(htmlcode);
    this.setCursorAtLocator(new domlevel.Locator(this.getContentBodyNode()));
  }

  setContentsHTMLRaw(htmlcode)
  {
    this.editarea.setBodyHTML(htmlcode);
    this.setCursorAtLocator(new domlevel.Locator(this.getContentBodyNode()));
  }

  toElement()
  {
    return this.editelement;
  }

  createElement(nodename)
  {
    return this.getDoc().createElement(nodename);
  }

  createTextNode(text)
  {
    return this.getDoc().createTextNode(text);
  }

  /** Returns a $wh.Rich.range with the current selection, constrained to body node/editelement. The returned
      range is limited to the contentbodynode, and descended into leaf nodes.

      @return Copy of the current selection
  */
  getSelectionRange(options)
  {
    var skipnormalize = options && options.skipnormalize;

    var bodynode = this.getContentBodyNode();

    if (this.hasFocus())
    {
      var range = this.editarea.framemanager.selectionitf.getSelectionRange();
      if (range)
      {
        if(domlevel.getRangeLogLevel() & 4)
          console.log('getSelectionRange have native selection (limited to body node)', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range, true), range.start, range.end);

        range.limitToNode(bodynode);
        if (!range.isLegal(this.getContentBodyNode()))
        {
          console.log('normalize illegal range');
          range.normalize(this.getContentBodyNode());
          this.editarea.framemanager.selectionitf.selectRange(range);

          if(domlevel.getRangeLogLevel() & 4)
            console.log('getSelectionRange native was not legal. After normalize', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range, true), range.start, range.end);
        }
        this.currentrange = range;
      }
      else if (this.currentrange)
      {
        this.currentrange.limitToNode(bodynode);

        if (domlevel.getRangeLogLevel() & 4)
          console.log('getSelectionRange no native selection, use saved', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.currentrange, true), this.currentrange.start, this.currentrange.end);
      }
    }
    else if (this.currentrange)
    {
      this.currentrange.limitToNode(bodynode);

      if (domlevel.getRangeLogLevel() & 4)
        console.log('getSelectionRange no focus, use saved', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.currentrange, true), this.currentrange.start, this.currentrange.end);
    }

    if (!this.currentrange)
    {
      // No focus yet, and no saved selection - use default (start of document)
      var locator = new domlevel.Locator(bodynode);
      this.currentrange = new domlevel.Range(locator, locator);
      if(domlevel.getRangeLogLevel() & 4)
        console.log('getSelectionRange no saved selection', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.currentrange, true), this.currentrange.start, this.currentrange.end);
    }

    var retval = this.currentrange.clone();
    if (!skipnormalize)
    {
      retval.normalize(bodynode, true);
      if(domlevel.getRangeLogLevel() & 4)
        console.log('getSelectionRange normalized selection', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), retval, true), retval.start, retval.end);
    }

    return retval;
  }

  /** Changes the current selection to the passed range
      @param range Range to select
  */
  selectRange(range, options)
  {
    if (!domlevel.isNodeSplittable(range.start.element))
      throw "Trying to put start of selection within an unsplittable element (" + range.start.element.nodeName + ')';
    if (!domlevel.isNodeSplittable(range.end.element))
      throw "Trying to put end of selection within an unsplittable element (" + range.end.element.nodeName + ')';

    var body = this.getContentBodyNode();
    this.currentrange = range.clone();

    if(domlevel.getRangeLogLevel() & 64)
      console.log('selectrange before limit', richdebug.getStructuredOuterHTML(body, this.currentrange, true), this.currentrange.start, this.currentrange.end);
    this.currentrange.limitToNode(body);
    if(domlevel.getRangeLogLevel() & 64)
      console.log('selectrange after limit', richdebug.getStructuredOuterHTML(body, this.currentrange, true), this.currentrange.start, this.currentrange.end);

    if (!options || !options.skipnormalize)
    {
      this.currentrange.normalize(body);
      if(domlevel.getRangeLogLevel() & 64)
        console.log('selectrange after normalize', richdebug.getStructuredOuterHTML(body, this.currentrange, true), this.currentrange.start, this.currentrange.end);
    }

    //console.log('B selectingrange set', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range, true));
    this.selectingrange = true;

    //FIXME formerly this.editarea.selectRange(range);
//    this.currentrange.limitToNode(body);
//    this.currentrange.normalize(this.getContentBodyNode(), false);


/*    //FIXME only if connected ?!  if(this.editarea.connected)
    this.editarea.framemanager.selectionitf.selectRange(this.currentrange);
*/

    if(this.hasFocus())
      this.editarea.framemanager.selectionitf.selectRange(this.currentrange);


    if(domlevel.getRangeLogLevel() & 64)
      console.log('EA selectRange', this.connected, richdebug.getStructuredOuterHTML(body, range, false));

    this.selectingrange = false;
    //console.log('B selectingrange res', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.getSelectionRange(), true));

    this.stateHasChanged();
  }

  setCursorAtLocator(locator)
  {
    this.selectRange(new domlevel.Range(locator, locator));
  }

  selectNodeInner(node)
  {
    this.selectRange(domlevel.Range.fromNodeInner(node));
  }

  selectNodeOuter(node)
  {
    this.selectRange(domlevel.Range.fromNodeOuter(node));
  }

  collapseSelection(tostart)
  {
    var range = this.getSelectionRange();
    if (tostart)
      range.end.assign(range.start);
    else
      range.start.assign(range.end);
    this.selectRange(range);
  }

  debugGetRawSelectionRange() // DEBUG
  {
    return this.editarea.getSelectionRange();
  }

  debugGetRawRawSelectionRange() // DEBUG
  {
    return this.editarea.debugGetRawSelectionRange();
  }

  xGetRangyWrapper() { return new SelectionInterface(this.getContentBodyNode()); }

  editareaconnect()
  {
    this.editarea.connect();

    // No Firefox, we don't want your fancy inline table editing or object resizing (can only be called _after_ editarea is
    // connected, i.e. contentEditable is set)
    this.execCommand("enableInlineTableEditing", null, "false");
    this.execCommand("enableObjectResizing", null, "false");

    this.stateHasChanged();
  }
  editareadisconnect()
  {
    this.editarea.disconnect();

    this.stateHasChanged();
  }

  reprocessAfterExternalSet()
  {
    //external update to the value. reset the selection, the delayed surrounds
    this.currentrange = null;
    this.delayedsurrounds = [];

    var range = this.getSelectionRange();
    this.selectRange(range);
  }
  SetBackgroundColor(color) //FIXME must be unused...
  {
    this.options.backgroundcolor = color;
  }
  SetBreakupNodes(nodenames)
  {
    if (nodenames && nodenames.length)
      this.breakupnodes = nodenames;
    else
      this.breakupnodes = [];
  }
  onFocus(event)
  {
    // Restore the focus on onfocus event. But don't if focusing because of a click on editable stuff
    if (this.currentrange && !this.ignorenextfocus)
    {
      this.editarea.framemanager.selectionitf.selectRange(this.currentrange);
    }

    // Need to explicitly disable inline table editing here, doing it once just isn't enough.
    if (browser.getName() === "firefox")
    {
      document.execCommand("enableInlineTableEditing", null, "false");
      document.execCommand("enableObjectResizing", null, "false");
    }

    this.ignorenextfocus = false;

    this.updateTableEditors();
  }

  onFocusOut(event)
  {
    // On focus out, try to get the current selection (will work when we still have focus)
    // This will save the current selection to this.currentrange, so we can restore upon focusin
    this.getSelectionRange({ skipnormalize: true });

    /* The RTE has a tendency to regain focus on Chrome. Easily tested by selecting
       a range, select 'create hyperlink' and immediately typing - the tollium
       hyperlink window is not taking focus.
       APply workaround from http://jsfiddle.net/pfsNx/26/ ( https://code.google.com/p/chromium/issues/detail?id=89026 )
       */
    if(/AppleWebKit\/([\d.]+)/.exec(navigator.userAgent))
    {
      if(!editableFix)
      {
        editableFix = document.createElement('input');
        editableFix.style.cssText = "width:1px;height:1px;border:none;margin:0;padding:0;position:absolute;bottom;0;left:0;visibility:hidden";
        editableFix.tabIndex = -1;
        document.body.appendChild(editableFix);
      }
      editableFix.setSelectionRange(0, 0);
      if(event.relatedTarget)
        event.relatedTarget.focus();
    }
  }

  onFocusIn(event)
  {
    // Restore the selection (FIXME: this might cause problems when focus lies within an embedded object)
    if (this.currentrange && !this.ignorenextfocus)
      this.editarea.framemanager.selectionitf.selectRange(this.currentrange);

    // Ignore the next focus event
    this.ignorenextfocus = true;
  }


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Formatting
//
  applyTextStyle(textstyle, apply)
  {
    //ADDME proper list of textstyles we should prevent?
    if(!['b','i','u','strike','sub','sup'].contains(textstyle))
      console.warn("ADDME: Didn't test ApplyTextStyle for '" + textstyle + "' yet");

    this.DelayedSurroundSelection( { element: textstyle
                                   , wrapin: apply
                                   , splitprohibits: [ 'a' ]
                                   , splitblockelements: false
                                   } );
  }


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Contents API
//

  setCursor(element, offset)
  {
    if (!element)
      throw "Invalid element passed to setCursor";

    this.setCursorAtLocator(new domlevel.Locator(element, offset || 0));
  }

  SetSelection(newrange)
  {
    this.selectRange(domlevel.Range.fromDOMRange(newrange));
  }

  SelectAll()
  {
    this.selectNodeInner(this.getContentBodyNode());
    this.stateHasChanged();
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //  New selection API
  //
  selectNodeContents(node)
  {
    console.warn('selectNodeContents is deprecated, use selectNodeInner!');console.trace();
    this.selectRange(domlevel.Range.withinNode(node));
  }

  insertTextAtCursor (text)
  {
    //console.log('setselt: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), domlevel.Range.fromDOMRange(this.GetSelectionObject().GetRange())));

    var range = this.getSelectionRange();
    if (!range.isCollapsed())
      throw new Error("insertTextAtCursor does not support selections");

   // selection is collapsed, so range start = range end, so we can just use range start
//    console.log('insertTextAtCursor DescendLocatorToLeafNode locators.start');
    range.start.descendToLeafNode(this.getContentBodyNode());

    // locators.start should now point to a text node, insert the text
    var textnode = range.start.element;
    var textoffset = range.start.offset;
    if (textnode.nodeType != 3) // If it's not a text node (e.g. in an empty document), create one
    {
      if (textnode.childNodes.length)
        textnode = textnode.insertBefore(this.getDoc().createTextNode(''), textnode.childNodes.item(textoffset));
      else
        textnode = textnode.appendChild(this.getDoc().createTextNode(''));
      textoffset = 0;
    }
    var nodetext = textnode.nodeValue;
    nodetext = nodetext.substr(0, textoffset) + text + nodetext.substr(textoffset);
    textnode.nodeValue = nodetext;

    this.selectRange(
      new domlevel.Range(
        new domlevel.Locator(textnode, textoffset),
        new domlevel.Locator(textnode, textoffset + text.length)));
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //  Undo API
  //

  getUndoItem(selectionrange)
  {
    if (!this.options.allowundo)
      return null;

    var last = this.undostack.getLast();
    if (last && !last.finished)
    {
      console.warn('Last undo item not finished!');
      this.undostack = [];
      this.undopos = 0;
    }

    var item = new EditorUndoItem(this, selectionrange ? selectionrange.clone() : this.getSelectionRange());
    this.undostack.splice(this.undopos, this.undostack.length - this.undopos, item);
    ++this.undopos;

//    var xRangyWrapper = this.xGetRangyWrapper();
//    xRangyWrapper.selectRange(domlevel.Range.fromNodeInner(this.undonode));
//    this.undonode.ownerDocument.execCommand('inserttextAtCursor', false, this.undopos);

    return item;
  }

  changeUndoPosition(newpos)
  {
    var nothrow = false;
    try
    {
      while (newpos < this.undopos)
      {
        --this.undopos;
        this.undostack[this.undopos].undo();
      }
      while (newpos > this.undopos && this.undopos < this.undostack.length)
      {
        this.undostack[this.undopos].redo();
        ++this.undopos;
      }
      this.undopos = newpos;
      nothrow = true;
    }
    finally
    {
      if (!nothrow)
      {
        this.undostack = [];
        this.undopos = 0;
      }
    }
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //  Dom analyzing
  //

  /** Describes the first ancestor blocknode of a block. If no block is found, the block section node is returned
      in all values.
      @param node Block node (or child thereof)
      @return
      @cell return.node Block top node (p/h1..h6/ol/ul)
      @cell return.contentnode Block content node (li if node is the li node of a list or inside of it, otherwise equal to the block top node)
      @cell return.blockparent Parent of the block node
      @cell return.blockroot Root ancestor of the blocks (body, td, th or content body)
  */
  getBlockAtNode(node)
  {
    // Look out - can also be used within document fragments!
    let root = this.getContentBodyNode();

    let res =
        { node:         null
        , contentnode:  null
        , blockroot:    null
        , blockparent:  null
        , islist:       false
        , isintable:    false
        };

    let curnode=node;
    for(;curnode&&curnode!=root;curnode=curnode.parentNode)
      if (curnode.nodeType == 1)
      {
        if (['tr','td'].includes(curnode.nodeName.toLowerCase()))
          res.isintable = true;

        if (curnode.nodeName.toLowerCase() == 'li')
          res.contentnode = curnode;
        else if (domlevel.isNodeBlockElement(curnode))
        {
          let islist =[ 'ol', 'ul' ].contains(curnode.nodeName.toLowerCase());
          if(this.getBlockStyleByTag) //FIXME why do we care?
            res.blockstyle = curnode.className ? this.getBlockStyleByTag(curnode.className) : null;
          res.node = curnode;
          res.contentnode = (islist && res.contentnode) || curnode;
          res.blockparent = curnode.parentNode;
          res.islist = islist;
          break;
        }
        else if (this.blockroots.contains(curnode.nodeName.toLowerCase())) // FIXME: better name for listunbreakablenodes
        {
          res.node = curnode;
          res.contentnode = curnode;
          res.blockroot = curnode;
          res.blockparent = curnode.parentNode;
          break;
        }
      }
      else if (curnode.nodeType == 11)
        root = curnode;

    for (;curnode&&curnode!=root;curnode=curnode.parentNode)
    {
      if (curnode.nodeType == 11)
        root = curnode;
      else if (curnode.nodeType == 1 && this.blockroots.contains(curnode.nodeName.toLowerCase())) // FIXME: better name for listunbreakablenodes
      {
        res.blockroot = curnode;
        break;
      }
    }

    res.node = res.node || root;
    res.contentnode = res.contentnode || root;
    res.blockroot = res.blockroot || root;
    res.blockparent = res.blockparent || root;


//    console.log('getBlockAtNode res: ', res);

    return res;
  }

  /** Returns all the blocks in a range
      @param range
      @return
      @cell type 'block'/'range'
      @cell range
      @cell block
  */
  getBlocksInRange(range, withinnerlists)
  {
    range = range.clone();
    //var orgrange = range.clone();

    // Move range to include the whole block (including sublists)
    range.start.moveToPreviousBlockBoundary(this.getContentBodyNode(), true);

    // If end is placed before all visible content in a block, need to place it before the its block (but after range.start!)
    if (range.end.movePastLastVisible(this.getContentBodyNode()).type == 'outerblock')
    {
      // When <p>...</p><p>(*end*), place the end in the previous block
      range.end.ascend(this.getContentBodyNode(), false);
      // Now: <p>...</p>(*end*)<p> or <body>(*end*)<p>
      // Make sure no content is left between the left block and the end locator
      range.end.moveToPreviousBlockBoundary(this.getContentBodyNode(), false);
      // And keep the range valid
      if (range.end.compare(range.start) < 0)
        range.end.assign(range.start);
    }
    else
    {
      range.end.moveToNextBlockBoundary(this.getContentBodyNode(), !withinnerlists);
    }

    var blocknodes = [];

    // FIXME: use something to limit maxancestor to nearest <body><td><th>
    //var startblocknode = range.start.element;
    //var endblocknode = range.end.element;

    var elts = range.getElementsByTagName('*');
    for (let i = 0; i < elts.length; ++i)
    {
      if (!elts[i].isContentEditable || !domlevel.isNodeBlockElement(elts[i]))
        continue;
      blocknodes.push(elts[i]);
    }

    var blocks = [];
    for (let i = 0; i < blocknodes.length; ++i)
    {
      let block = this.getBlockAtNode(blocknodes[i]);
      if (block.islist && block.contentnode == block.node)
        continue;

      blocks.push({ type: 'block', block: block });
    }

    if (range.start.element == range.end.element)
    {
      let block = this.getBlockAtNode(range.start.element);
      if (block.contentnode == block.blockparent) // Non-block enclosed text
      {
        if (blocknodes.length == 0)
        {
          blocks.push({ type: 'range', range: range });
        }
        else
        {
          var startrange = range.clone();
          startrange.end.assign(startrange.start);
          startrange.end.moveToNextBlockBoundary(this.getContentBodyNode());

          if (!startrange.isCollapsed())
            blocks.unshift({ type: 'range', range: startrange });

          var endrange = range.clone();
          endrange.start.assign(startrange.start);
          endrange.start.moveToPreviousBlockBoundary(this.getContentBodyNode());

          if (!endrange.isCollapsed())
            blocks.push({ type: 'range', range: endrange});
        }
      }
      else
        blocks.push({ type: 'block', block: block });
    }

    return blocks;
  }

  /** Updates a path with the next node. All elements that are not a proper ancestor of node are removed, then
      node is appended.
      @param path Current path
      @param node New node
      @return Whether the node had no ancestor in the old path
  */
  updatePathForNextNode(path, node)
  {
    var found = false;
    for (var n = path.length - 1; !found && n >= 0; --n)
    {
      if (path[n].contains(node))
      {
        // Remove all non-ancestor elements from the array
        path.splice(n + 1, path.length - n - 1);
        found = true;
        break;
      }
    }

    if (!found)
      path.splice(0, path.length);
    path.push(node);

    return found;
  }

  getLevelActionableListNodes(range)
  {
    // Keep range intact
    range = range.clone();

    // Adjust the range, so all partially selected <li>'s fall within the range (otherwise they won't be returned by
    // getElementsByTagName)
    var startliparent = domlevel.findParent(range.start.getNearestNode(), "li", this.getContentBodyNode());
    if (startliparent)
      range.start.assign(domlevel.Locator.newPointingTo(startliparent));

    var endliparent = domlevel.findParent(range.end.getNearestNode(), "li", this.getContentBodyNode());
    if (endliparent)
    {
      if (endliparent == startliparent)
      {
        range.end.assign(domlevel.Locator.newPointingAfter(startliparent));
      }
      else
      {
        range.end.ascend(this.getContentBodyNode(), false);
        var endlistart = domlevel.Locator.newPointingTo(endliparent);
        var endliend = domlevel.Locator.newPointingAfter(endliparent);
        // If the end <li> is partially selected, select the whole <li>
        if (range.end.compare(endlistart) > 0)
          range.end = endliend;
      }
    }

    let linodes = Array.slice(range.getElementsByTagName('li'));

    var addable = [], removeable = [];

    // Find the nodes that can be added a level
    var path = [];
    for (let i = 0; i < linodes.length; ++i)
    {
      if (!linodes[i].isContentEditable)
        continue;

      if (!linodes[i].previousSibling)
      {
        // If this is the first li within a list, and there is another list directly before this list, it may be added to that list
        var prevlist = domlevel.Locator.newPointingTo(linodes[i].parentNode);
        prevlist.moveToPreviousBlockBoundary(linodes[i].parentNode.parentNode, true);
        //console.log('glaln prevlist:', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { prevlist: prevlist }, true));
        prevlist = prevlist.getPointedNode();
        if (!prevlist || prevlist == linodes[i].parentNode || (prevlist.nodeName.toUpperCase() != "UL" && prevlist.nodeName.toUpperCase() != "OL"))
          continue;
      }
      else if (linodes[i].previousSibling.nodeType != 1 || linodes[i].previousSibling.nodeName.toLowerCase() != 'li')
        continue;

      // Don't select partial nodes when our selection starts in a list within that node
      if (startliparent && linodes[i] != startliparent && linodes[i].contains(startliparent))
        continue;

      if (!this.updatePathForNextNode(path, linodes[i]))
        addable.push(linodes[i]);
    }

    // Find the nodes that can be removed a level
    path = [];
    for (let i = 0; i < linodes.length; ++i)
    {
      if (!linodes[i].isContentEditable)
        continue;

      if (!domlevel.findParent(linodes[i].parentNode, "li", this.getContentBodyNode()))
        continue;

      // Don't select partial nodes when our selection starts in a list within that node
      if (linodes[i] != startliparent && linodes[i].contains(startliparent))
        continue;

      if (!this.updatePathForNextNode(path, linodes[i]))
        removeable.push(linodes[i]);
    }
    return { addable: addable, removeable: removeable };
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //  Dom manipulation, internal
  //

  /** If the after the locator, there is no visible content inside the block element where the locator is placed,
      insert a <br> (only when browser needs it, and that means IE)
      @param locator
      @param preservelocators
      @param undoitem
  */
  requireVisibleContentInBlockAfterLocator(locator, preservelocators, undoitem)
  {
    var blocknode = this.getBlockAtNode(locator.element).contentnode;
    domlevel.requireVisibleContentInBlockAfterLocator(locator, blocknode, this.createElement.bind(this), preservelocators, undoitem);
  }

  /** Removes a range and move the contents after the ranges inside the block at the start range
      @param range Range to remove
      @param undoitem
      @return Locator at place of removed range
  */
  _removeRangeAndStitch(range, undoitem)
  {
    var debugras = true;

    // Make sure we can insert at the start, and insert a temporary node to make sure splitdom
    // returns the current block in part[0]
    range.splitStartBoundary(null, undoitem);
    var insertpos = range.start.clone();

    var tnode = this.createElement("img"); // Img elements are more stable than text nodes - not combined
    range.start = range.start.insertNode(tnode, [ range.end ], undoitem);

    // Determine which blocks we start&end in
    var startblock = this.getBlockAtNode(range.start.getNearestNode());
    var endblock = this.getBlockAtNode(range.end.getNearestNode());
    var blockend = new domlevel.Locator(endblock.contentnode, "end");

    // make sure we are splitting block node (li or block)
    var wantancestor;
    if (startblock.node != startblock.contentnode) // List?
      wantancestor = startblock.node;
    else
      wantancestor = startblock.blockroot;

    // Determine the root we are splitting in
    var root = range.getAncestorElement();
    if (wantancestor.contains(root))
      root = wantancestor;

    if(debugras)
      console.log('_removeRangeAndStitch start:', richdebug.getStructuredOuterHTML(root, { root:root, range:range }));

    if(debugras)
      console.log('enter presplit:  ', richdebug.getStructuredOuterHTML(root, { range_start: range.start, range_end: range.end, blockend: blockend }));
    var parts = domlevel.splitDom(root, [ { locator: range.start, toward: 'start' }, { locator: range.end, toward: 'end' }, { locator: blockend, toward: 'end' } ], null, undoitem);
    if(debugras)
      console.log('enter postsplit: ', richdebug.getStructuredOuterHTML(root, parts));

    /* Ranges:
        0: content before range (keep, except our temporary element)
        1: content within range (delete)
        2: content after range end until block end (append to 0)
        3: content after block where range end is located (keep)
    */

    // Remove the contents of range 1, keep the other part locators valid
    domlevel.removeSimpleRange(parts[1], parts.concat([ insertpos ]), undoitem);

    var insertlocator = new domlevel.Locator.newPointingTo(tnode);
    insertlocator.removeNode(parts.concat([ insertlocator ]), undoitem);

    // Content to append?
    if (!parts[2].start.equals(parts[2].end))
    {
      var res = domlevel.removeSimpleRange(parts[2], parts, undoitem);
      var locator = new domlevel.Locator(res.fragment);
      locator.descendToLeafNode(this.getContentBodyNode());

      // See if there is a block in the removed fragment. If so, move only its contents.
      var restblock = this.getBlockAtNode(locator.getNearestNode());

      if(debugras)
      {
        console.log('_removeRangeAndStitch preinsert:', richdebug.getStructuredOuterHTML(root, { insertlocator: insertlocator }));
        console.log('fragment:  ', richdebug.getStructuredOuterHTML(res.fragment, restblock));
      }
      insertlocator = this.appendNodeContentsAfterRemove(insertlocator, restblock.contentnode, undoitem);
    }
    else
    {
      if(debugras)
        console.log('no preinsert');
      this.requireVisibleContentInBlockAfterLocator(insertlocator, null, undoitem);
    }

    if(debugras)
      console.log('_removeRangeAndStitch done:', richdebug.getStructuredOuterHTML(root, { insertlocator: insertlocator }));
    return insertlocator;
  }

  appendNodeContentsAfterRemove(insertlocator, contentnode, preservelocator, undoitem)
  {
    var nodes = domlevel.removeNodeContents(contentnode, undoitem);
    domlevel.insertNodesAtLocator(nodes, insertlocator, [], undoitem);
    return insertlocator;
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //  Dom manipulation, unsorted/untranslated
  //

  /* * Removes a range and move the contents after the ranges inside the block at the start range
      X because there is a function in structured with the same name and roughly the same functionality.
  */
  _removeRangeAndStitchX(range, preservelocators, undoitem)
  {
    preservelocators = (preservelocators||[]).slice();

    // No need to do work on empty selections
    range.normalize(this.getContentBodyNode());
    if (range.isCollapsed())
      return range.start.clone();

      // Make sure we can insert at the start, and insert a temporary node to make sure splitdom
    // returns the current block in part[0]
    range.splitStartBoundary(undoitem);
    var insertpos = range.start.clone();

    var tnode = this.createElement("img"); // Img elements are more stable than text nodes - not combined
    range.start = range.start.insertNode(tnode, [ range.end ], undoitem);

    // Determine which blocks we start&end in
    var startblock = this.getBlockAtNode(range.start.getNearestNode());
    var endblock = this.getBlockAtNode(range.end.getNearestNode());
    var blockend = null;

    // Determine the root we are splitting in
    var root = range.getAncestorElement();

    // Spanning different blocks!
    if (startblock.contentnode != endblock.contentnode)
    {
      blockend = new domlevel.Locator(endblock.contentnode, "end");
    }
    else
    {
      blockend = new domlevel.Locator(range.end.element, "end");
    }
//
//    // make sure we are splitting block node (li or block)
//    var wantancestor;
//    if (startblock.contentnode != endblock.contentnode)
//      wantancestor
//
//
//    if (startblock.node != startblock.contentnode) // List?
//      wantancestor = startblock.node;
//    else
//      wantancestor = startblock.blockroot;
//
//    if (domlevel.isAncestorOf(wantancestor, root))
//      root = wantancestor;

    //console.log('removeRangeAndStitch start:', richdebug.getStructuredOuterHTML(root, { root:root, range:range, blockend: blockend }));

    //console.log('enter presplit:  ', richdebug.getStructuredOuterHTML(root, { range_start: range.start, range_end: range.end, blockend: blockend }));
    var parts = domlevel.splitDom(root, [ { locator: range.start, toward: 'start' }, { locator: range.end, toward: 'end' }, { locator: blockend, toward: 'end' } ], preservelocators, undoitem);
    //console.log('enter postsplit: ', richdebug.getStructuredOuterHTML(root, parts));

    // Ranges:
    //    0: content before range (keep, except our temporary element)
    //    1: content within range (delete)
    //    2: content after range end until block end (append to 0)
    //    3: content after block where range end is located (keep)

    preservelocators = preservelocators.concat(parts);
    preservelocators.push(insertpos);

    // Remove the contents of range 1, keep the other part locators valid
    domlevel.removeSimpleRange(parts[1], preservelocators, undoitem);

    var insertlocator = new domlevel.Locator.newPointingTo(tnode);
    insertlocator.removeNode(preservelocators, undoitem);

    // Content to append?
    if (!parts[2].start.equals(parts[2].end))
    {
      let locator = parts[2].start.clone();
      locator.descendToLeafNode(this.getContentBodyNode());

      // See if there is a block in the removed fragment. If so, move only its contents.
      var restblock = this.getBlockAtNode(locator.getNearestNode());

      // restblock.contentnode contains the data. But it might also be the rootblock. Intersect with parts[2] for that!
      range = domlevel.Range.fromNodeInner(restblock.contentnode);
      range.intersect(parts[2]);

      var res = domlevel.moveSimpleRangeTo(range, insertlocator, parts, undoitem);

      // Calculate range to remove
      range = new domlevel.Range(res.afterlocator, parts[2].end);
      range.start.ascend(root, true, true);

      domlevel.removeSimpleRange(range, preservelocators, undoitem);
    }
    else
    {
      //console.log('no preinsert');
      this.requireVisibleContentInBlockAfterLocator(insertlocator, preservelocators, undoitem);
    }

    insertlocator = this._correctWhitespaceAroundLocator(insertlocator, undoitem);

    range.start.assign(insertlocator);
    range.end.assign(insertlocator);

    //console.log('removeRangeAndStitch done:', richdebug.getStructuredOuterHTML(root, { insertlocator: insertlocator }));
    return insertlocator;
  }

  /// Corrects whitespace around a locator, assuming the whitespace after the locator should be visible
  _correctWhitespaceAroundLocator(locator, undoitem)
  {
    // pointing to a text node?
    if ([3,4].includes(locator.getNearestNode().nodeType))
      locator = domlevel.combineAdjacentTextNodes(locator, undoitem);

    const prevlocator = locator.clone();
    const prevres = prevlocator.scanBackward(this.getContentBodyNode(), {});
    if (prevres.type === "whitespace")
      domlevel.rewriteWhitespace(this.getContentBodyNode(), prevlocator, [ locator ], undoitem);

    if (!prevlocator.equals(locator))
    {
      const nextlocator = locator.clone();
      const nextres = nextlocator.scanForward(this.getContentBodyNode(), {});
      if (nextres.type === "whitespace")
        domlevel.rewriteWhitespace(this.getContentBodyNode(), nextlocator, [ locator ], undoitem);
    }

    return locator;
  }

  replaceRangeWithNode(range, newnode, undoitem)
  {
    if (newnode)
      range.insertBefore(newnode, [], undoitem);

    return this._removeRangeAndStitchX(range, null, undoitem);
  }

  replaceSelectionWithNode(newnode, select)
  {
    var range = this.getSelectionRange();
    var undoitem = this.getUndoItem(range);
    var res = this.replaceRangeWithNode(this.getSelectionRange(), newnode, undoitem);
    if(select)
      this.selectNodeOuter(newnode);
    else
      this.setCursorAtLocator(res);

    if (undoitem)
      undoitem.finish(this.getSelectionRange());
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //  Actions
  //

  executeSoftEnter()
  {
    var range = this.getSelectionRange();
    var undoitem = this.getUndoItem(range);

    var iscollapsed = range.isCollapsed();

    // First insert the new br node
    var newbr = this.createElement('br');
    /*var res = */range.insertBefore(newbr, [], undoitem);

    // If we had a selection, then remove it
    if (iscollapsed)
    {
      this.requireVisibleContentInBlockAfterLocator(range.start, null, undoitem);
      this.setCursorAtLocator(range.start);
    }
    else
      this.setCursorAtLocator(this._removeRangeAndStitchX(range, null, undoitem));

    if (undoitem)
      undoitem.finish(this.getSelectionRange());
    this.stateHasChanged();
    return false;
  }

  /** Free RTE needs to break blockquotes - the rest of the browser implementation is good enough
      @return Whether browser implementation is to be used
  */
  executeHardEnter()
  {
    var range = this.getSelectionRange();

    // Find blockquotes at start - but don't break through tables
    var breakparent = domlevel.findParent(range.start.element, [ 'blockquote', 'th', 'td' ], this.getContentBodyNode());
    var topblockquote;
    while (breakparent)
    {
      if (breakparent.nodeName.toLowerCase() != 'blockquote')
        break;

      topblockquote = breakparent;
      breakparent = domlevel.findParent(breakparent.parentNode, [ 'blockquote', 'th', 'td' ], this.getContentBodyNode());
    }

    if (topblockquote)
    {
      var undoitem = this.getUndoItem(range);
      var parts = domlevel.splitDom(topblockquote.parentNode, [ { locator: range.start, toward: 'end' } ], range, undoitem);
      parts[1].start.insertNode(this.createElement('br'), [], undoitem);
      this.setCursorAtLocator(parts[1].start);
      if (undoitem)
        undoitem.finish();
      this.stateHasChanged();
      return false;
    }
    return true;
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //  Dom manipulation, rest
  //

  ReplaceSelection(splitparent, newnode)
  {
    var range = this.getSelectionRange();
    var undoitem = this.getUndoItem(range);
    var locators = range;

    if (!splitparent)
      splitparent = domlevel.Locator.findCommonAncestorElement(locators.start, locators.end);

    // Split the splitparent at selection start (and end if selection isn't empty)
    var splitlocators = [ { locator: locators.start, toward: 'start' } ];
    if (locators.start.element != locators.end.element || locators.start.offset != locators.end.offset)
      splitlocators.push({ locator: locators.end, toward: 'end' });

    //console.log('rs presplit: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), splitlocators.map(function(item){return item.locator;})));
    var parts = domlevel.splitDom(splitparent, splitlocators, undoitem);
      //console.log(parts);
    //console.log('rs post: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), parts));

    // Find last node before cursor position (highest ancestor of right element of first part)
    var leftborder = parts[0].end.element;
    while (leftborder.parentNode && leftborder.parentNode != splitparent)
      leftborder = leftborder.parentNode;

    // Find first node after cursor position (highest ancestor of left element of last part)
    var rightborder = parts[parts.length - 1].start.element;
    while (rightborder.parentNode && rightborder.parentNode != splitparent)
      rightborder = rightborder.parentNode;

    //console.log('rs post: ', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), { leftborder: leftborder, rightborder: rightborder, splitparent: splitparent }));

    if (leftborder.parentNode != splitparent || rightborder.parentNode != splitparent)
      return;

    // Clear all nodes between border nodes
    if (leftborder != rightborder)
      while (leftborder.nextSibling && leftborder.nextSibling != rightborder)
        leftborder.parentNode.removeChild(leftborder.nextSibling);

    if (leftborder != rightborder && leftborder.nextSibling != rightborder)
      return;

    // Insert new node between border nodes
    rightborder.parentNode.insertBefore(newnode, rightborder);

    // Select new node (outer, may be a <br> or <img>)
    this.selectNodeOuter(newnode);
  }

  getCurrentAnchor()
  {
    var node = this.getBlockAtNode(this.getSelectionRange().getAncestorElement()).contentnode;
    return node ? node.getAttribute('data-rtd-anchor') || '' : '';
  }

  setAnchor(newanchor)
  {
    var node = this.getBlockAtNode(this.getSelectionRange().getAncestorElement()).contentnode;
    if(!node)
      return;
    if(newanchor)
      node.setAttribute('data-rtd-anchor',newanchor);
    else
      node.removeAttribute('data-rtd-anchor');
    this.stateHasChanged();
  }

  insertImage(url, width, height)
  {
    var img = domtools.create("img", { src: url
                                     , className: "wh-rtd__img"
                                     });
    if(width && height)
    {
      img.height = height;
      img.width = width;
    }

    this.replaceSelectionWithNode(img, true);
    this.stateHasChanged();
  }

  insertHyperlink(url, options)
  {
    this._surroundSelection( { element: 'a'
                             , wrapin: true
                             , attrs: { href: url
                                      , target: options && options.target ? options.target : null
                                      }
                             , splitprohibits: []
                             , avoidwhitespace: true
                             } );
    this.stateHasChanged();
  }

  removeHyperlink()
  {
    var range = this.getSelectionRange();
    if (range.isCollapsed())
    {
      // No selection: find the A node that is the parent of the cursor and select that one
      // ADDME: unselect and keep current cursor position
      //var range = sel.GetRange();
      var path = (new domlevel.Locator(range.getAncestorElement())).getPathFromAncestor(this.getContentBodyNode());

      for (var i = path.length-1; i >= 0; --i)
        if (path[i].nodeName.toLowerCase() == 'a')
        {
          this.selectRange(domlevel.Range.withinNode(path[i]));
          break;
        }

      // No A node found
      if (i == -1)
        return;
    }

    this._surroundSelection( { element: 'a'
                            , wrapin: false
                            , splitprohibits: []
                            });
  }

  insertTable(cols, rows)
  {
    throw new Error("insertTable not overridden");
  }

  // Toggle bulleted list for the selection
  _toggleBulletedList()
  {
    this.execCommand('insertunorderedlist');
    this.stateHasChanged();
  }

  // Toggle numbered list for the selection
  _toggleNumberedList()
  {
    this.execCommand('insertorderedlist');
    this.stateHasChanged();
  }

  //ADDME: Use our own function instead of having the browser make something up
  _setAlignment(align)
  {
    var cmd = '';
    switch (align)
    {
      case 'center':
        cmd = 'justifycenter';
        break;
      case 'right':
        cmd = 'justifyright';
        break;
      case 'justified':
        cmd = 'justifyfull';
        break;
      default: // 'left'
        cmd = 'justifyleft';
        break;
    }
    this.execCommand(cmd);
    this.stateHasChanged();
  }

  _undo()
  {
    //this.ExecCommand('undo');
  }

  _redo()
  {
    //this.ExecCommand('redo');
  }

  _clearFormatting()
  {
    //ADDME: Only clear formatting of selected contents?
    var body = this.getContentBodyNode();
    this.setContentsHTML(GetOuterPlain(body, true));
    this.stateHasChanged();
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //  Private API
  //

  _registerFrameEventListeners()
  {
    this.editarea.registerBodyEvent('keydown', this._gotKeyDown.bind(this));
    this.editarea.registerBodyEvent('keypress', this._gotKeyPress.bind(this));
    this.editarea.registerBodyEvent('keyup', this._gotKeyUp.bind(this));//*/
    this.editarea.registerBodyEvent('mousedown', this._gotMouseDown.bind(this));
    this.editarea.registerBodyEvent('mouseup', this._gotMouseUp.bind(this));
    this.editarea.registerBodyEvent('click', this._gotMouseClick.bind(this));
    this.editarea.registerBodyEvent('paste', this._gotPaste.bind(this));
    this.editarea.registerBodyEvent('cut', this._gotCut.bind(this));
    this.editarea.registerBodyEvent('dblclick', this._gotDoubleClick.bind(this));

    if (browser.getName() === "firefox")
      this.editarea.registerBodyEvent('DOMNodeRemoved', this._gotDOMNodeRemoved.bind(this));
  }

  _getImageDownloadURL()
  {
    return this.options.imgloadplaceholder || defaultimgplaceholder;
  }

  _createImageDownloadNode()
  {
    return domtools.create("img", { src: this._getImageDownloadURL() });
  }

  _isStillImageDownloadNode(img)
  {
    return img.src == (this.options.imgloadplaceholder || defaultimgplaceholder);
  }

  _debugDataTransfer(event)
  {
    Array.each(event.clipboardData.items, function(item)
      {
        console.log("CP item", item, item.kind);

        if(item.kind=="string")
          item.getAsString(function(str) {console.warn(str);});
        else if(item.kind=="file")
        {
          var reader = new FileReader();
          reader.onload = function(event)
          {
            console.warn(event.target.result);
          };
          reader.readAsDataURL(item.getAsFile());
        }
      });
  }

  async uploadPastedImage(type, data, node)
  {
    console.error(type,data,node);
    let busylock = dompack.flagUIBusy();
    try
    {
      if(type == 'datatransfer')
        await this.uploadImageToServer(data, node);
      else if(type == 'url') //uploading remote image
        await this.uploadImageByURLToServer(data,node);
    }
    finally
    {
      busylock.release();
    }
  }

  _gotPaste(event)
  {
    if(WHBase.debug.rte)
      console.log('[rte] paste', this, event);

    this.gotPaste(event);
  }

  async gotPaste(event)
  {
    if(event && event.clipboardData && event.clipboardData.items)
    {
      //this._debugDataTransfer(event);

      for(var i=0;i<event.clipboardData.items.length;++i)
      {
        var item = event.clipboardData.items[i];
        if(item.type == "image/png")
        {
          let file = item.getAsFile();
          if(!file)
            return; //giving up then

          var repl = this._createImageDownloadNode();
          this.replaceSelectionWithNode(repl, true);
          await this.uploadPastedImage('datatransfer', file, repl);
          //setTimeout(() => this.handlePasteDone(), 1); why go through this when just replacing one image ?
          return;
        }
      }
    }

    // Wait for the paste to happen, then
    setTimeout(() => this.handlePasteDone(), 1);
  }

  async handlePasteDone()
  {
    let imgs = qSA(this.getContentBodyNode(),'img');
    imgs = imgs.filter(img => !this.rte.knownimages.includes(img.src) && !this._isStillImageDownloadNode(img) && img.isContentEditable);
    if(!imgs.length) //nothing to do
      return;

    let busylock = dompack.flagUIBusy();
    try
    {
      let replacementpromises = [];
      for(let img of imgs)
      {
        let downloadsrc = img.src;
        img.src = this._getImageDownloadURL();

        replacementpromises.push(formservice.getImgFromRemoteURL(downloadsrc)
          .then (result => this._handleUploadedRemoteImage(img, result) )
          .catch(result => this._handleUploadedRemoteImage(img, null) ));
      }
      await Promise.all(replacementpromises);
    }
    finally
    {
      busylock.release();
    }
  }

  _handleUploadedRemoteImage(img, properurl)
  {
    if(!properurl)
    {
      dompack.replaceWith(img);
    }
    else
    {
      img.src = properurl;
      this.rte.knownimages.push(properurl);
    }
  }
  /* Surround selection directly if there is a selection, otherwise delay surrounding the selection until there was something
     typed */
  DelayedSurroundSelection(elementinfo)
  {
    if (this.getSelectionRange().isCollapsed())
    {
      //console.log('Delaying SurroundSelection');

      // If already on queue, see if canceling or repeating old action
      for (var i = 0; i < this.delayedsurrounds.length; ++i)
      {
        var info = this.delayedsurrounds[i];
        if (info.element == elementinfo.element)
        {
          if (info.wrapin == elementinfo.wrapin)
            return; // Already on queue

          // Canceling queued action by deleting it from the queue
          this.delayedsurrounds.splice(i, 1);
          //console.log('Currently '+this.delayedsurrounds.length+' surrounds delayed');
          this.stateHasChanged();
          return;
        }
      }
      // Add the action to the queue, execute it when there is a selection (i.e. when the user has typed something)
      this.delayedsurrounds.push(elementinfo);
      //console.log('Currently '+this.delayedsurrounds.length+' surrounds delayed');
      this.stateHasChanged();
    }
    else
    {
      // We have a selection, so execute the action immediately
      this._surroundSelection(elementinfo);
    }
  }

  ClearDelayedSurrounds()
  {
    //console.log('ClearDelayedSurrounds');console.trace();
    while (this.delayedsurrounds.length)
      this.delayedsurrounds.pop();
  }

  _createNodeFromElementInfo(elementinfo)
  {
    var newnode = this.createElement(elementinfo.element);
    if(elementinfo.attrs)
    {
      var attrnames = Object.keys(elementinfo.attrs).sort();
      for (var i = 0; i < attrnames.length; ++i)
        if(elementinfo.attrs[attrnames[i]] !== null)
          newnode.setAttribute(attrnames[i], elementinfo.attrs[attrnames[i]]);
    }
    return newnode;
  }

  _canWrapNode(elementinfo, node)
  {
    if (domlevel.isNodeBlockElement(node))
      return elementinfo.splitblockelements == true;
    return !(elementinfo.splitprohibits && elementinfo.splitprohibits.contains(node.nodeName.toLowerCase()));
  }

  _mustWrapNode(elementinfo, node)
  {
    return false;
  }

  surroundRange(range, elementinfo, undoitem)
  {
    //console.log('surroundrange start', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range));
    //var result = domlevel.surroundRange(range, elementinfo);

    domlevel.removeNodesFromRange(range, this.getContentBodyNode(), elementinfo.element, null, undoitem);

    if (elementinfo.wrapin)
    {
      console.log(elementinfo);
      domlevel.wrapRange(
            range,
            () => this._createNodeFromElementInfo(elementinfo),
            node => this._canWrapNode(elementinfo, node),
            node => this._mustWrapNode(elementinfo, node),
            null,
            undoitem);
    }

    //console.log('surroundrange end', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range));
  }

  _surroundSelection(elementinfo)
  {
    var undoitem = this.getUndoItem();

    var range = this.getSelectionRange();
    if(elementinfo.avoidwhitespace)
    {
      //Try to remove spaces at begin and end iterator
      while(range.start.element.nodeType==3 && range.start.element.textContent[range.start.offset] == ' ' && range.start.compare(range.end) < 0)
        ++range.start.offset;
      while(range.end.element.nodeType==3 && range.end.element.textContent[range.end.offset-1] == ' ' && range.start.compare(range.end) < 0)
        --range.end.offset;
    }
    this.surroundRange(range, elementinfo, undoitem);
    this.selectRange(range);

    if (undoitem)
      undoitem.finish(this.getSelectionRange());
  }

  stateHasChanged(firstcall) //ADDME check all code for superfluous calls (eg, invoking stateHasChange after invoking SetSelection which also did a stateHasChanged)
  {
    //save state before firing the event. save on processing with multiple getSelectionState calls, and make sure we have a selection state after display:none on firefox
    this.lastselectionstate = this.getFormattingStateForRange(this.getSelectionRange());

    // Update all table editors as tables' positions or contents may have changed
    this.updateTableEditors();

    this.onstatechange && this.onstatechange({ firstcall: firstcall });
  }

  getSelectionState()
  {
    return this.lastselectionstate;
  }

  getTextStyleRecordFromNode(node)
  {
    var nodeName = node.nodeName.toLowerCase();
    if (nodeName == 'strong')
      nodeName = 'b';
    else if (nodeName == 'em')
      nodeName = 'i';
    else if (nodeName == 'a' && node.hasAttribute("href"))
      nodeName = "a-href";

    return (
        { nodeName:  nodeName
        });
  }

  isActionSupported(actionname) //do we support the requested (toolbar) action?
  {
    return [ "a-href"
           , "b", "i", "u", "sup", "sub", "strike"
           , "img", "action-properties", "action-clearformatting"
           ].contains(actionname);
  }

  getAvailableBlockStyles(selstate)
  {
    return [];
  }

  getActionsForNode(node)
  {
    var actions=[];
    for (var i=0;i<this.options.actionelements.length;++i)
    {
      var act = this.options.actionelements[i];
      if(act.element != node.nodeName.toLowerCase())
        continue;
      if(act.hasattributes)
      {
        let ismatch=true;
        for (let j=0;j<act.hasattributes.length;++j)
        {
          if(!node.hasAttribute(act.hasattributes[j]))
            ismatch=false;
        }
        if(!ismatch)
          continue;
      }
      if(act.hasclasses)
      {
        let ismatch=true;
        for (let j=0;j<act.hasclasses.length;++j)
          if(!node.hasClass(act.hasclasses[j]))
            ismatch=false;
        if(!ismatch)
          continue;
      }
      actions.push(act);
    }
    return actions;
  }

  checkActionElements(node, formatting)
  {
    this.getActionsForNode(node).each(function(action)
      {
        formatting.actionelements.push(action);
        formatting.actiontargets.push(node);
      });
  }

  getFormattingStateForRange(range)
  {
    if(domlevel.getRangeLogLevel()&16)
      console.log("gFSR received range",range, range.start, range.end);

    var formatting = new TextFormattingState();

    // Range might be null, when we have an uninitialized iframe
    if (!range)
      return formatting;

    // We're modifying range in here
    range = range.clone();

    /* Word's behaviour:
       if there is a selection:
         bold, italic and underline are true if all characters in the selection hves that state
       if there is no selection:
         look at the previous character?

       Our behaviour:
       if there is any hyperlink within the selection
         hyperlink is true
       no selection:
         hyperlink at current character?
    */

    var alignment = '';

    formatting.haveselection = !range.isCollapsed();

    var locator = range.start.clone();

    if(domlevel.getRangeLogLevel()&16)
      console.log('selected before ascend', richdebug.getStructuredOuterHTML(range.getAncestorElement(), range));

    /*
    if (range.isCollapsed())
    {
      // FIXME: went wrong somehow, locator.element becomes null in moveToParent (comparison with bodynode?)
      while (locator.element && locator.element != this.editelement && locator.offset == 0)
      {
        range.start.assign(locator);
        range.end.assign(locator);
        locator.moveToParent();
      }
      if (locator.element)
      {
        range.start.assign(locator);
        range.end.assign(locator);
      }
    } */

//    console.log('selected after ascend', richdebug.getStructuredOuterHTML(range.getAncestorElement(), range));


    var anchornode = locator.element && locator.getNearestNode();

//    if(this.options.log)
//      console.log("Iterate parents");
//    var anchornode = sel.Node();
    for(let curnode = anchornode;curnode && curnode != this.editelement;curnode=curnode.parentNode)
    {
      switch(curnode.nodeName.toUpperCase())
      {
        case 'B': case 'STRONG': /* FIXME shouldn't generate STRONGs! */
        case 'I': case 'EM': /* FIXME shouldn't generate EMs! */
        case 'U':
        case 'INS':
        case 'DEL':
        case 'SUP':
        case 'SUB':
        case 'STRIKE':
          formatting.textstyles.push(this.getTextStyleRecordFromNode(curnode));
          break;
        case 'A':
          formatting.textstyles.push(this.getTextStyleRecordFromNode(curnode));
          formatting.hyperlink=true;
          break;
        case 'UL':
          formatting.bulletedlist=true;
          break;
        case 'OL':
          formatting.numberedlist=true;
          break;

        case 'CENTER':
          alignment = alignment || 'center';
          break;

        case 'TABLE':
          formatting.tables.push(curnode);
          break;
      }
      if (curnode.getAttribute && curnode.getAttribute('align'))
        alignment = alignment || curnode.getAttribute('align');
      else if (curnode.style && curnode.style.textAlign)
        alignment = alignment || curnode.style.textAlign;
    }
    // Assuming left alignment when no other alignment is specified
    alignment = alignment || 'left';

    formatting.alignleft = alignment == 'left';
    formatting.aligncenter = alignment == 'center';
    formatting.alignright = alignment == 'right';
    formatting.alignjustified = alignment == 'justified';

    /* Action elements must be given back
       - first from within the range, DOM order
       - second from ancestor to root
    */

    var relevantnodes = range.getElementsByTagName('*');

    // Filter out non-contenteditable nodes (allow divs within a contenteditable parent)
    relevantnodes = relevantnodes.filter(function(node)
    {
      if (node.isContentEditable)
        return true;
      return node.nodeName.toUpperCase() == 'DIV' && node.parentNode.isContentEditable;
    });

    for(let curnode = range.getAncestorElement();curnode && curnode != this.editelement;curnode=curnode.parentNode)
      relevantnodes.push(curnode);

    if(domlevel.getRangeLogLevel()&16)
      console.log('all gfsfr relevantnodes', relevantnodes);

    for (let i = 0; i < relevantnodes.length; ++i)
    {
      var node = relevantnodes[i];

      switch (node.nodeName.toUpperCase())
      {
        case 'A':
          formatting.hyperlink = true;
          break;
        case 'UL':
          formatting.bulletedlist=true;
          break;
        case 'OL':
          formatting.numberedlist=true;
          break;
      }
      this.checkActionElements(node, formatting);
    }

    // check delayed surrounds
    for (let i=0; i<this.delayedsurrounds.length; ++i)
    {
      var info = this.delayedsurrounds[i];
      var found = false;
      for (var pos = 0; pos < formatting.textstyles.length; ++pos)
      {
        if (formatting.textstyles[pos].nodeName == info.element)
        {
          formatting.textstyles.splice(pos, 1);
          found = true;
          break;
        }
      }
      if (!found)
        formatting.textstyles.push({ nodeName: info.element });
    }

    formatting.properties = formatting.actionelements.length != 0;

    var listdata = this.getLevelActionableListNodes(range);
    var actionparent = domlevel.findParent(anchornode, [ 'ol', 'ul', 'td', 'th' ], this.getContentBodyNode());
    formatting.actionparent = actionparent;

    // When the cursor is at the start of the next block, correct the end position to the end of the previous block element.
    var end_locator = range.end.clone();
    end_locator.scanBackward(this.getContentBodyNode(), { blocks: true, alwaysvisibleblocks: true });
    if (range.start.compare(end_locator) > 0) // Don't go past start
      end_locator = range.start;

    var startblock = this.getBlockAtNode(range.start.element).contentnode;
    var limitblock = this.getBlockAtNode(end_locator.element).contentnode;

    var allow_td_actions = startblock == limitblock && actionparent && [ "th", "td" ].contains(actionparent.nodeName.toLowerCase());
    var tableeditor = allow_td_actions && TableEditor.getEditorForNode(actionparent.getParent("table"));

    formatting.actionstate =
        { "li-increase-level":
              { available:  listdata.addable.length != 0
              }
        , "li-decrease-level":
              { available:  listdata.removeable.length != 0
              }
        , "a-href":
              { available:  !range.isCollapsed() || formatting.hyperlink
              }
        , "img":
              { available:  true//formatting.hasTextStyle("img")
              }
        , "action-properties":
              { available:  formatting.actionelements.length != 0
              }
        , "b":
              { available:  true
              , active:     formatting.hasTextStyle('b')
              }
        , "i":
              { available:  true
              , active:     formatting.hasTextStyle('i')
              }
        , "u":
              { available:  true
              , active:     formatting.hasTextStyle('u')
              }
        , "strike":
              { available:  true
              , active:     formatting.hasTextStyle('strike')
              }
        , "sub":
              { available:  true
              , active:     formatting.hasTextStyle('sub')
              }
        , "sup":
              { available:  true
              , active:     formatting.hasTextStyle('sup')
              }
        , "ol":
              { available:  true
              , active:     actionparent && actionparent.nodeName.toLowerCase() == 'ol'
              }
        , "ul":
              { available:  true
              , active:     actionparent && actionparent.nodeName.toLowerCase() == 'ul'
              }
        , "p-id":
              { available:  startblock == limitblock //only when we cover one block
              , active:     startblock.hasAttribute('data-rtd-anchor') //'id' is translated to data-rtd-anchor on load for safety
              }
        , "table-addrow-before":      { available: allow_td_actions }
        , "table-addrow-after":       { available: allow_td_actions }
        , "table-addpara-before":      { available: allow_td_actions }
        , "table-addpara-after":       { available: allow_td_actions }
        , "table-addcolumn-before":   { available: allow_td_actions }
        , "table-addcolumn-after":    { available: allow_td_actions }
        , "table-deleterow":          { available: allow_td_actions && tableeditor && tableeditor.numrows != 1 }
        , "table-deletecolumn":       { available: allow_td_actions && tableeditor && tableeditor.numcolumns != 1 }
        };

    return formatting;
  }

  _gotCut(event)
  {
    // Check the dom after a cut
    this.scheduleCallbackOnInputOrDelay(this.checkDomStructure.bind(this), 'checkdom');
  }

  OnSelectionChange(event)
  {
    if (this.selectingrange) // Currently within our own selection calls, ignore
      return;

    /* This function corrects selections that give problems when replacing. It restricts selections
       that start in a table cell to that cell.

       Also, if the selection starts outside a table, and ends within one, the table is removed from the selection
    */

    //console.log.apply(console, richdebug.getStructuredOuterHTML(null, { range: range, base: base }, { title: "OSC start", colorize: true }));
    const { changed, range } = this._constrainRangeCrossTDSelections(this.getSelectionRange());

    if (changed)
      this.selectRange(range);
  }

  // Used on FF only!
  _gotDOMNodeRemoved(event)
  {
    // Node removed that's a child of the content node? Check the dom!
    // Needed because of select all+delete in context menu in ff & no selection change events
    if (event.relatedNode == this.getContentBodyNode())
      this.scheduleCallbackOnInputOrDelay(this.checkDomStructure.bind(this), 'checkdom');
  }

  SubtreeModified(target)
  {
    if(this.insubtreemod)
      return;

    this.insubtreemod=true;
    this.CleanupChildren(target);
    this.insubtreemod=false;
  }

  /** Check DOM structure
      @param range Range (optional, if range not set, use (& restore!) current selection)
  */
  checkDomStructure(range, preservelocators)
  {
  }

  tableEditorStateHasChanged()
  {
    // When the tableeditor triggers a state change, delay and coalesce the trigger
    // This because a state change triggers table editor updates again. Don't want to recurse them.
    if (!this.tableeditorstatechangedelay)
    {
      this.tableeditorstatechangedelay = setTimeout(() =>
      {
        this.tableeditorstatechangedelay = null;
        this.stateHasChanged();
      }, 0);
    }
  }

  initializeTableEditor(tablenode, resizing)
  {
    var editor = TableEditor.getEditorForNode(tablenode);
    if (editor)
    {
      editor.updateResizers();
      return;
    }

    var options = { onStatechange: this.tableEditorStateHasChanged.bind(this) };
    if (resizing)
    {
      options.resize_columns = resizing.contains("all") || resizing.contains("columns");
      options.resize_rows = resizing.contains("all") || resizing.contains("rows");
      options.resize_table = resizing.contains("all") || resizing.contains("table");
    }

    editor = new TableEditor(tablenode, this.getContentBodyNode(), options);
    this.tableeditors.push(editor);
  }

  _getEditableTables()
  {
    return [];
  }

  updateTableEditors()
  {
    // Get list of all editable tables
    var list = this._getEditableTables();
    list.each(function(listitem)
    {
      this.initializeTableEditor(listitem.node, listitem.tableresizing);
    }, this);

    // Destroy editors that are no longer active (i.e. the associated table is no longer present in the DOM), update active
    // editors
    this.tableeditors = this.tableeditors.filter(function(editor)
    {
      var active = editor.isActive();
      if (!active)
        editor.destroy();
      return active;
    });

    // upon the first call we want to setup some measures to
    // be able to react to custom fonts having been loaded
    if(!this.__updateTableEditorsSetupDone)
    {
      this.__updateTableEditorsSetupDone = true;

      if(document.fonts && "onloadingdone" in document.fonts) //FF41+ and Chrome 35+ implement this
      {
        //whenever a font is loaded, resize table editors
        this.fontslistener = this.updateTableEditors.bind(this);
        document.fonts.addEventListener("loadingdone", this.fontslistener);
      }
      else // IE, Edge and Safari
      {
        // Keep updating the tableeditors for 5 seconds to give the rte time to load external css and fonts
        this.repeatupdatetableuntil = Date.now() + 5000;
      }
    }

    if(this.repeatupdatetableuntil && Date.now() < this.repeatupdatetableuntil && !this.scheduledupdatetableeditors)
    {
      //reschedule us on the next available frame after 200ms has passed
      this.scheduledupdatetableeditors = true;
      this.repeatupdatetabletimeout = setTimeout( (function() { this.repeatupdatetableanimframe = requestAnimationFrame(this.rescheduledUpdateTableEditors.bind(this)); }).bind(this), 200);
    }
  }



  rescheduledUpdateTableEditors()
  {
    this.scheduledupdatetableeditors = false;
    this.updateTableEditors();
  }

  _executeDeleteByKey(forward)
  {
    return false; // let the browser handle it
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //  Event handling
  //

  _handleKeyCommand(event, names)
  {
    for (let keyname of names)
    {
      switch (keyname)
      {
        case "Ctrl+A":      {
                              event.preventDefault();
                              event.stopPropagation();
                              this.SelectAll();
                            } return;
        case "Ctrl+B":      { // apply bold
                              event.preventDefault();
                              event.stopPropagation();
                              this.executeAction("b");
                            } return;
        case "Ctrl+I":      { // I: Apply italic
                              event.preventDefault();
                              event.stopPropagation();
                              this.executeAction('i');
                            } return;
        case "Ctrl+U":      { // U: Apply underline
                              event.preventDefault();
                              event.stopPropagation();
                              this.executeAction('u');
                            } return;
        case "Ctrl+Y":
        case "Ctrl+Z":      { // Y: redo, Z: Undo
                              if (this.undonode)
                                this.undonode.focus();
                            } return;
        case "Shift+Enter": {
                              event.preventDefault();
                              event.stopPropagation();
                              this.executeSoftEnter();
                            } return;
        case "Enter":       {
                              if (!this.executeHardEnter())
                              {
                                event.preventDefault();
                                event.stopPropagation();
                                return;
                              }
                            } break;
        case "Tab":
        case "Shift+Tab":   { //these can affect apps, just prevent them from bubbling up, they have meaning to us..
                              event.stopPropagation();
                            } break;
        case "Delete":      {
                              if (this._executeDeleteByKey(true))
                              {
                                event.preventDefault();
                                event.stopPropagation();
                                return;
                              }
                            } break;
        case "Backspace":   {
                              if (this._executeDeleteByKey(false))
                              {
                                event.preventDefault();
                                event.stopPropagation();
                                return;
                              }
                            } break;
      }
    }
  }

  _gotKeyDown(event)
  {
    if(!this.hasFocus())
    {
      event.preventDefault();
      console.log("Received keydown without having focus");
      return; //this keydown shouldn't have gotten here!
    }

    // Firefox doesn't have anything like selectionchange, so we need to do that before keys arrive
    if (browser.getName() === "firefox")
      this.OnSelectionChange(null);

    // User input is being handled, handle input events now!
    this._detectedInputEvent(event);

    this._handleKeyCommand(event, keyboard.getEventKeyNames(event));

    // Something might be done with this press, schedule a state update
    (function()
    {
      this.OnSelectionChange(event);
      this.stateHasChanged();
    }.bind(this).delay(1));

    return true;
  }

  _gotKeyPress(event) //ADDME generalize/configurable key mappings. should this really be part of the whrte core anyway?
  {
    let eventdata = dompack.normalizeKeyboardEventData(event);
    console.log("keypress", eventdata.key, eventdata);
    if (eventdata.ctrlKey)
      return;
/*
    {
      switch (eventdata.key)
      {
        case "A": // select all
        {
          this.SelectAll();
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        case "B": // apply bold
        {
          this.executeAction("b");
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        case "I": // I: Apply italic
        {
          this.executeAction('i');
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        case "U": // U: Apply underline
        {
          this.executeAction('u');
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        case "Y":
        case "Z": // Y: redo, Z: Undo
        {
          if (this.undonode)
            this.undonode.focus();
          return;
        }
      }
      return; // Leave other key combinations alone
    }
*/
    this.OnSelectionChange(event);

    // enters keep delayed surrounds intact
    if (eventdata.key === "Enter")
      return;

    // Check the dom structure before applying the change. The cursor might be in an illegal place.
    this.checkDomStructure();

    var range = this.getSelectionRange();

    //console.log('keypressed', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), range));
    //console.log(range.isCollapsed(), this.delayedsurrounds.length);
/*
    if (eventdata.key === "Enter")
    {
      console.log(eventdata.key, eventdata);
      if (eventdata.shiftKey)
      {
        event.preventDefault();
        event.stopPropagation();
        this.executeSoftEnter();
        return false;
      }
      if (!this.executeHardEnter())
      {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }
*/
    if (this.delayedsurrounds.length)
    {
      if (!range.isCollapsed() || eventdata.key.length !== 1)
        this.ClearDelayedSurrounds();
      else
      {
        // Insert the pressed character at the current cursor position
        //console.log('pre sst "' + String.fromCharCode(charCode) + '"', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.getSelectionRange()));
        this.insertTextAtCursor(eventdata.key);
        //console.log('post sst', richdebug.getStructuredOuterHTML(this.getContentBodyNode(), this.getSelectionRange()));

        //console.log('onKeyPressed, delay, pre: ', this.getContentsHTML());

        // Execute delayed surrounds
        for (var i=0; i<this.delayedsurrounds.length; ++i)
          this._surroundSelection(this.delayedsurrounds[i]);
        this.ClearDelayedSurrounds();

        //console.log('onKeyPressed, delay, post: ', this.getContentsHTML());

        // Set cursor directly after inserted text
        this.collapseSelection();
        //this.GetSelectionObject().Collapse();

        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }

    return true;
  }

  _gotKeyUp(event)
  {
    let eventdata = dompack.normalizeKeyboardEventData(event);

    // Don't clear delayed surrounds on enter, so they'll be transferred to the next line
    if (eventdata.key !== "Enter")
      this.ClearDelayedSurrounds();

    this.OnSelectionChange(event);
    this.stateHasChanged();
    return true;
  }

/*
  OnInput(event)
  {
    this.OnSelectionChange(event);
    this.stateHasChanged();
    return true;
  }
*/
  _gotMouseDown(event)
  {
    this.ClearDelayedSurrounds();

    // When clicking on an image, select it
    if (event.target.nodeName.toUpperCase() == "IMG")
      this.selectNodeOuter(event.target);

    this.OnSelectionChange(event);
    this.stateHasChanged();

    // Delay 1 ms to pick up text selection changes for context menus. Also delay the context menu by 1ms and everything will be ok
    (function()
    {
      this.OnSelectionChange(event);
      this.stateHasChanged();
    }.bind(this).delay(1));
    return true;
  }

  _gotMouseUp(event)
  {
    this.ClearDelayedSurrounds();
    (function()
    {
      this.OnSelectionChange(event);
      this.stateHasChanged();
    }.bind(this).delay(1));
  }

  _gotMouseClick(event)
  {
    if (!event.target)
      return;

    // Find parent 'a' node
    var anode = domlevel.findParent(event.target, 'a', this.getContentBodyNode());
    if (anode)
    {
      // Get attribute href. No type spec, so we get the absolute link
      var href = anode.getAttribute('href');
      if (href)
      {
        if (event.ctrl)
          window.open(href, '_blank');

        // Cancel the mouse click
        event.stopPropagation();
        event.preventDefault();
        return false;
      }
    }
  }
  _gotDoubleClick(event)
  {
    //ADDME should there be more doubleclickable?
    if(event.target && event.target.nodeName.toUpperCase() == "IMG")
    { //double click on an image should open the action props
      this.selectNodeOuter(event.target);
      this.executeAction('action-properties');
    }
    event.stopPropagation();
    event.preventDefault();
  }

  setInputEventAttach(attach)
  {
    if (this.attachedinputevents == attach)
      return;

    if (!this.inputeventfunction)
      this.inputeventfunction = this._detectedInputEvent.bind(this);

    if (attach)
    {
      this.getDoc().addEventListener('selectionchange', this.inputeventfunction);
      this.getContentBodyNode().addEventListener('input', this.inputeventfunction);
    }
    else
    {
      this.getDoc().removeEventListener('selectionchange', this.inputeventfunction);
      this.getContentBodyNode().removeEventListener('input', this.inputeventfunction);
    }

    this.attachedinputevents = attach;
  }

  scheduleCallbackOnInputOrDelay(callback, name)
  {
    if (this.activeinputhandler == name)
      return;

    for (var i = 0; i < this.oninputhandlers.length; ++i)
      if (this.oninputhandlers[i].name == name)
        return;

    if (!this.oninputhandlers.length)
    {
      this.setInputEventAttach(true);
      this._delayedDetectedInputEvent(null);
    }

    this.oninputhandlers.push({ name: name, callback: callback });
  }

  _delayedDetectedInputEvent(event)
  {
    if (event)
      Promise.resolve(true).then(() => this._detectedInputEvent(event));
    else
      setTimeout(() => this._detectedInputEvent(null), 1);
  }

  _detectedInputEvent(event)
  {
    // Currently inside range code, just ignore
    if (this.selectingrange)
      return;

    if (this.oninputhandlers.length)
    {
      //console.log('inputdelay activated by ' + (event ? 'event ' + event.type : 'timeout'));
      var copy = this.oninputhandlers.slice();
      this.oninputhandlers = [];
      this.setInputEventAttach(false);

      for (var i = 0; i < copy.length; ++i)
      {
        this.activeinputhandler = copy[i].name;
        copy[i].callback();
      }

      this.activeinputhandler = '';
    }
  }

  setShowFormatting(show)
  {
    // Get the currently applied classes array
    var classes = this.getContentBodyNode().className.split(" ");
    // If new show state not explicitly given, toggle show state
    show = typeof show == "boolean" ? show : !classes.contains("wh-rtd-formatting");
    // Add/remove the formatting class
    if (show)
      classes.include("wh-rtd-formatting");
    else
      classes.erase("wh-rtd-formatting");
    // Apply the new class names
    this.getContentBodyNode().className = classes.join(" ");
    this.stateHasChanged();
  }

  getShowFormatting()
  {
    return this.getContentBodyNode().className.split(" ").contains("wh-rtd-formatting");
  }
/*
  _launchActionPropertiesFromList(actionelements, targetnode, subaction)
  {
    var targetid = this._registerActionTarget(targetnode);
    var evt = new PropertiesEvent(this.rte, targetnode, targetid, targetnode, subaction);

    this.rte.fireEvent("properties", evt);

    if(!evt.defaultPrevented && actionelements[0].properties)
    {
      //legacy path...
      console.warn("the properties event should be handled and cancelled");
      actionelements[0].properties(targetid, targetnode, subaction);
    }
    else if(!evt.defaultPrevented)
    {
      this.executeDefaultPropertiesAction(evt);
    }
  }
*/
  executeDefaultPropertiesAction(event)
  {
  }
  /*
  launchActionProperties()
  {
    var selstate = this.getSelectionState();
    if(selstate.actionelements.length == 0)
      return;

    this._launchActionPropertiesFromList(selstate.actionelements, selstate.actiontargets[0]);
  }
*/
  /// Get an id for an action target (which can be used through RPC's and then used later using getActionTarget)
  _registerActionTarget(targetnode)
  {
    // FIXME: allow only one target in flight, mix in local id (unique per rtebase in rte) / edittoken?
    this.actiontargets.push(targetnode);
    return this.actiontargets.length;
  }

  getActionTarget(targetid)
  {
    var target = targetid > 0 && targetid <= this.actiontargets.length ? this.actiontargets[targetid-1] : null;
    if(target)
    {
      var findbody = this.getContentBodyNode();
      for(var trynode = target; trynode; trynode = trynode.parentNode)
        if(trynode == findbody)
          return target; //good news, the target is still in the DOM. Enjoy!
    }
    return null;
  }

  async newUploadInsertImage()
  {
    let lock = dompack.flagUIBusy();
    let files = await compatupload.selectFiles();
    if(!files.length)
    {
      lock.release();
      return;
    }

    try
    {
      let imgnode = this._createImageDownloadNode();
      this.replaceSelectionWithNode(imgnode, true);
      await this.uploadImageToServer(files[0], imgnode);
    }
    finally
    {
      lock.release();
    }
  }

  //Upload an image to the server, and then replace the src in the specified image node
  async uploadImageToServer(filetoupload, imgnode)
  {
    let uploader = new compatupload.UploadSession([filetoupload]);//ADDME - should identify us as permitted to upload eg , { params: { edittoken: ...} });
    let res = await uploader.upload();
    let properurl = await formservice.getImgEditFinalURL(res[0].url);
    imgnode.src = properurl;
    this.rte.knownimages.push(imgnode.src);
    imgnode.classList.add("wh-rtd__img");

    await preload.promiseImage(imgnode.src); //don't return until the upload is done!
  }
  //FIXME if we can select embeddedobjects, we can merge this into executeAction
  launchActionPropertiesForNode(node, subaction)
  {
    /* we're currently used ONLY for RTD subactions
    var actions = this.getActionsForNode(node);
    if(!actions.length)
      return;

    this._launchActionPropertiesFromList(actions, node, subaction);
    */
    let action = { action: 'action-properties'
                 , targetid: this._registerActionTarget(node)
                 , subaction: subaction
                 , rte: this.rte
                 };

    if(!legacybase.dispatchDomEvent(node, "wh:richeditor-action",
                         { bubbles: true
                         , cancelable: true
                         , detail: action
                         }))
      return;

    this.executeDefaultPropertiesAction({target:node, detail:action});
  }

  executeAction(action)
  {
    // Fallback for single string argument call without extra parameters - apparently everyone but the 'table' action doe sthis
    if (typeof action == "string")
      action = { action: action };

    let actionnode = this.options.eventnode; //FIXME legacy! should just fire to the closest event possible for all actions
    if (action)
    {
      if(!action.action)
        throw new Error("Expected an 'action' value");

      action.rte = this.rte; //this is the RTE object

      if(action.action == 'p-id')
        action.currentanchor = this.getCurrentAnchor();

      if(action.action == 'a-href')
      {
        let selstate = this.getSelectionState();
        if(selstate.hyperlink) //inside a hyperlink
          action.action = 'action-properties'; //rewrite to a properties action
      }

      if(action.action == 'action-properties')
      {
        var selstate = this.getSelectionState();
        if(selstate.actionelements.length == 0)
          return;

        actionnode = selstate.actiontargets[0];
        action.targetid = this._registerActionTarget(actionnode);

        action.actiontarget = { __node: actionnode };
        //action.subaction = not needed yet on this route
      }
    }

    if(!legacybase.dispatchDomEvent(actionnode, "wh:richeditor-action",
                         { bubbles: true
                         , cancelable: true
                         , detail: action
                         }))
      return;


// FIXME for custom butons
    switch (action.action)
    {
      case "img":
        this.newUploadInsertImage();
        break;
      case 'a-href':
        var url = prompt(this.GetLanguageText('prompt_hyperlink'), "http://");
        if (url)
          this.insertHyperlink(url);
        break;
      case 'remove_hyperlink':
        this.RemoveHyperlink();
        break;
      case 'p-id':
        this.setAnchor(prompt(this.GetLanguageText('prompt_anchor'), action.currentanchor));
        break;
      case 'table':
        if (!action.size)
          throw "Expected size param for table action";
        this.insertTable(action.size.x, action.size.y);
        break;
      case 'ul':
        this._toggleBulletedList();
        break;
      case 'ol':
        this._toggleNumberedList();
        break;
      case 'li-increase-level':
        this.addListLevel();
        break;
      case 'li-decrease-level':
        this.removeListLevel();
        break;
      case 'align_left':
      case 'align_center':
      case 'align_right':
      case 'align_justified':
        this._setAlignment(action.action.substr(6));
        break;
      case 'undo':
        this._undo();
        break;
      case 'redo':
        this._redo();
        break;
      case 'action-clearformatting':
        if (confirm(this.GetLanguageText("messages_confirmclearformatting")))
          this._clearFormatting();
        break;
      case 'action-showformatting':
        this.setShowFormatting(!this.getShowFormatting());
        break;
      case 'action-properties':
        this.executeDefaultPropertiesAction({target:actionnode, detail:action});
        break;

      case 'b':
      case 'u':
      case 'i':
      case 'strike':
        this.applyTextStyle(action.action, !this.getSelectionState().hasTextStyle(action.action));
        break;
      case 'sub': // sub & sup are mutually recursive
      case 'sup':
        if (!this.getSelectionState().hasTextStyle(action.action))
          this.applyTextStyle((action.action == 'sub' ? 'sup' : 'sub'), false);
        this.applyTextStyle(action.action, !this.getSelectionState().hasTextStyle(action.action));
        break;

      case "table-addpara-before":
      case "table-addpara-after":
      {
        let node = this.getSelectionState().actionparent;
        let tablenode = node.getParent("table");
        this.insertEmptyParagraph(tablenode, action.action === "table-addpara-after");
      } break;
      case "table-addrow-before":
      case "table-addrow-after":
      case "table-addcolumn-before":
      case "table-addcolumn-after":
      case "table-deletecolumn":
      case "table-deleterow":
      {
        var node = this.getSelectionState().actionparent;
        var tablenode = node.getParent("table");
        var editor = TableEditor.getEditorForNode(tablenode);
        switch (action.action)
        {
          case "table-addrow-before":
          case "table-addrow-after":      editor.insertRows(node, action.action === "table-addrow-before", 1, node.offsetHeight, { newcell_callback: this._initNewTableCell.bind(this) }); break;
          case "table-addcolumn-before":
          case "table-addcolumn-after":   editor.insertColumns(node, action.action === "table-addcolumn-before", 1, node.offsetWidth, { newcell_callback: this._initNewTableCell.bind(this) }); break;
          case "table-deleterow":         editor.deleteRows(node, 1); break;
          case "table-deletecolumn":      editor.deleteColumns(node, 1); break;
        }
        break;
      }
    }
  }

  /** Initialize a new table cell created by table-addrow/table-addcolumn
      @param cellnode Table cell node (td or th)
  */
  _initNewTableCell(cellnode)
  {
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //  Language texts
  //

  _getLangTexts()
  {
    if (!this._langtexts)
    {
      this._langtexts =
               { en: { buttonbar_bold: "Bold"
                     , buttonbar_italic: "Italic"
                     , buttonbar_underline: "Underline"
                     , buttonbar_insert_image: "Insert Image"
                     , buttonbar_insert_hyperlink: "Insert Hyperlink"
                     , buttonbar_remove_hyperlink: "Remove Hyperlink"
                     , buttonbar_anchor: "Bookmark"
                     , buttonbar_insert_table: "Insert Table"
                     , buttonbar_bulleted_list: "Bulleted List"
                     , buttonbar_numbered_list: "Numbered List"
                     , buttonbar_align_left: "Align left"
                     , buttonbar_align_center: "Center"
                     , buttonbar_align_right: "Align right"
                     , buttonbar_align_justified: "Justify"
                     , buttonbar_undo: "Undo"
                     , buttonbar_redo: "Redo"
                     , buttonbar_clear_formatting: "Clear Formatting"
                     , prompt_hyperlink: "Hyperlink URL"
                     , prompt_anchor: "Bookmark name"
                     , messages_openlink: "%1<br/><b>Shift + click to open in a new window</b>"
                     , messages_anchor: "Bookmark #%1"
                     , messages_confirmclearformatting: "Are you sure you want to discard all style?\n\nThis operation cannot be undone."
                     , messages_confirmclearcontents: "Are you sure you want to delete all contents?\n\nThis operation cannot be undone."
                     }
               , nl: { buttonbar_bold: "Vet"
                     , buttonbar_italic: "Cursief"
                     , buttonbar_underline: "Onderstrepen"
                     , buttonbar_insert_image: "Afbeelding invoegen"
                     , buttonbar_insert_hyperlink: "Hyperlink invoegen"
                     , buttonbar_remove_hyperlink: "Hyperlink verwijderen"
                     , buttonbar_anchor: "Bladwijzer"
                     , buttonbar_insert_table: "Tabel invoegen"
                     , buttonbar_bulleted_list: "Lijst met opsommingstekens"
                     , buttonbar_numbered_list: "Genummerde lijst"
                     , buttonbar_align_left: "Links uitlijnen"
                     , buttonbar_align_center: "Centreren"
                     , buttonbar_align_right: "Rechts uitlijnen"
                     , buttonbar_align_justified: "Uitvullen"
                     , buttonbar_undo: "Ongedaan maken"
                     , buttonbar_redo: "Opnieuw"
                     , buttonbar_clear_formatting: "Opmaak verwijderen"
                     , prompt_hyperlink: "URL voor de hyperlink"
                     , prompt_anchor: "Naam voor de bladwijzer"
                     , messages_openlink: "%1<br/><b>Shift + klik om in een nieuw venster te openen</b>"
                     , messages_anchor: "Bladwijzer #%1"
                     , messages_confirmclearformatting: "Weet u zeker dat u alle opmaak wilt verwijderen?\n\nDeze operatie kan niet ongedaan gemaakt worden."
                     , messages_confirmclearcontents: "Weet u zeker dat u alle inhoud wilt verwijderen?\n\nDeze operatie kan niet ongedaan gemaakt worden."
                     }
               };
    }
    return this._langtexts;
  }

  GetLanguageText(name, param1, param2)
  {
    let langtexts = this._getLangTexts();
    if (langtexts[this.language] && langtexts[this.language][name])
      return (langtexts[this.language][name]).split('%1').join(param1).split('%2').join(param2);
    return "";
  }

  requireBottomParagraph()
  {
    // overridden by structured editor
  }
}

class TextFormattingState
{
  constructor()
  {
    this.hyperlink = false;
    this.bulletedlist = false;
    this.numberedlist = false;
    this.alignleft = false;
    this.aligncenter = false;
    this.alignright = false;
    this.alignjustified = false;
    this.haveselection = false;

    this.textstyles = [];
    this.actionelements = [];
    this.actiontargets = [];

    this.actionstate = {};
    this.actionparent = null; // nearest ol/ul/td/th

    this.tables = [];
    this.blockstyle = null;
  }

  hasTextStyle(nodeName)
  {
    return this.getTextStyleByNodeName(nodeName) != null;
  }

  getTextStyleByNodeName(nodeName)
  {
    for (var i = 0; i < this.textstyles.length; ++i)
      if (this.textstyles[i].nodeName == nodeName)
        return this.textstyles[i];
    return null;
  }

}

EditorBase.TextFormattingState = TextFormattingState;
module.exports = EditorBase;



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/components/richeditor/internal/editorbase.es